import { useQuery } from '@tanstack/react-query';
import { isF1Device } from '../utils/isF1Device';

export const useF1AppVersion = () => {
  const appVersionQuery = useQuery({
    queryKey: ['f1AppVersion'],
    queryFn: () => {
      if (!isF1Device()) {
        return null;
      }
      return localStorage.getItem('app_version') ?? localStorage.getItem('ios_app_version');
    },
  });

  return appVersionQuery;
};
